import axios from "axios";



 const getCurrentGeoLocation = async () =>{
        let  position=null;
        console.log('start getCurrentGeoLocation');
        try {
            const current = await asyncCurrentPosition();
            console.log('result CurrentPosition ok');
            position = {
                latitude:current.coords.latitude,
                longitude:current.coords.longitude,
                type:"geolocation"
              };
        }catch(error){
            console.error(error);
        }
       
        if(!position){
            try{
            const result =  await asyncApiPosition();
            console.log('result asyncApiPosition ok');
            if(result && result.data && result.data.latitude && result.data.longitude){
                position = {
                    latitude: result.data.latitude,
                    longitude: result.data.longitude, 
                    type:"api"
                }
            }
            }catch(error){
                console.error(error);
            }           
        }
   return position; 
}

const asyncCurrentPosition =  ()=>{
    return new Promise( (resolve, reject) => {
        if (!navigator.geolocation){
            console.log('error navigator.geolocation == null');
            reject({
                code:0, 
                message:"navigator.geolocation == null"
            })
            return; 
        } 
       
        const options = {
            maximumAge: 30000,
            timeout: 8000,
            enableHighAccuracy: false
        };
        
        navigator.geolocation.getCurrentPosition(
            position => resolve(position),
            error => {
                console.log('error getCurrentPosition:', error);
                reject(error)
            }, 
            options
        )
    })
}

const asyncApiPosition = async ()=>{
    const serviceUrl = `https://ipapi.co/json`; 
    const result = await axios.get(serviceUrl)
    return result; 
}


/* Create a bounding box with sides ~30km away from the center point */
const getBoundingBox = (center,r) =>{
    const radius = r?r:0.3 //Km
    return {
      north: center.latitude + radius,
      south: center.latitude - radius,
      east: center.longitude + radius,
      west: center.longitude - radius,
    };
  }


  const googlePlaceToAddress = (newPlace)=>{
    const selectedPlace = {};
    selectedPlace.address = newPlace.formatted_address; 
    selectedPlace.details = ""; 
    selectedPlace.placeId = newPlace.place_id

    if(newPlace.geometry && newPlace.geometry.location){
       const geopoint = {
           latitude:newPlace.geometry.location.lat(),
           longitude: newPlace.geometry.location.lng(),
       }
       selectedPlace.geopoint = geopoint; 
    }
  return selectedPlace; 
}


const isGeopoint = (geopoint)=>{
    return geopoint && geopoint.latitude && geopoint.longitude
 }


 const  getAddressStatus = (address, editedGeopoint) =>{
    let status = undefined; 
    const geo = address.geopoint; 
    if(!geo &&  isGeopoint(editedGeopoint)){
      status = 'added'
    }else if(geo &&  equalsGeopoint(geo,editedGeopoint)){
      status = 'google'  
    }else if(geo &&  !equalsGeopoint(geo,editedGeopoint)){
      status = 'edited'  
    }
    return status; 
}

const equalsGeopoint = (a,b)=>{
    return a && b && a.latitude==b.latitude && a.longitude== b.longitude
 }



export {
    getCurrentGeoLocation,
    getBoundingBox, 
    googlePlaceToAddress, 
    isGeopoint, 
    getAddressStatus,
    asyncApiPosition 
}


